import React from 'react'

export default function NotFound() {
  return(
    <h2>{`404: not found`}</h2>
  )
}
